import React from "react";
import { Form } from "react-bootstrap";
import FormFieldLabel from "./FormFieldLabel/FormFieldLabel";

function FormPhoneField({ label, id, placeholder, value, onChange, required }) {
  return (
    <Form.Group className="formGroup">
      <FormFieldLabel label={label} />
      <Form.Control
        required={required}
        id={id}
        value={value === null ? "" : value}
        placeholder={placeholder}
        // 7-15 digits separated by spaces, hyphens, dots, slashes or
        // parentheses, with an optional "ext. 21" / "x21" / "#21" suffix.
        // Specials inside the class are escaped because browsers compile
        // `pattern` with the `v` flag.
        pattern="^\+?\(?[0-9](?:[\s\-.\/\(\)]{0,2}[0-9]){6,14}(?:\s*(?:[eE][xX][tT]\.?|[xX]|#)\s*[0-9]{1,6})?$"
        onChange={onChange}
        type="tel"
      />
    </Form.Group>
  );
}

export default FormPhoneField;
